import { Popover } from "@mui/material";
import React, { useEffect } from "react";
import { StyledList,  StyledListItemButton, StyledListItemText } from "./BasketListDotMenu.style";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";

export const BasketListDotsMenu: React.FC<{
  onClose?: any;
  anchorElement: HTMLButtonElement | null;
  onRenameBasket: any;
  onDeleteBasket: any;
  showDelete: boolean;
}> = ({
  anchorElement,
  onClose,
  onRenameBasket,
  onDeleteBasket,
  showDelete,
}) => {
  /*const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };*/

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    anchorElement
  );

  const [showDeleteState, setShowDeleteState] = React.useState<boolean>(
    showDelete
  );

  useEffect(() => {
    setAnchorEl(anchorElement);
  }, [anchorElement]);

  useEffect(() => {
    setShowDeleteState(showDelete);
  }, [showDelete]);

  const open = Boolean(anchorEl);
  const id = open ? "basketlist-actions" : undefined;

  const handleClose = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
    if (onClose) onClose();
  };

  const handleBasketRename = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
    if (onClose) onClose();
    onRenameBasket();
  };

  const handleBasketDelete = (event: any) => {
    
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
    if (onClose) onClose();
    onDeleteBasket();
  };

  const {t} = useTranslation();
  return (
      <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
              vertical: "center",
              horizontal: "left",
          }}
          transformOrigin={{
              vertical: "center",
              horizontal: "right",
          }}
          style={{ zIndex: 1000000 }}
          //classes={{ paper: partDetailClass.availabilityPopoverPaper }}
      >
          <StyledList aria-label="">
              <StyledListItemButton onClick={handleBasketRename}>
                  <StyledListItemText
                      primary={t("common.spareparts.basket.rename") as string}
                  />
              </StyledListItemButton>
              {showDelete && (
                  <StyledListItemButton onClick={handleBasketDelete}>
                      <StyledListItemText
                          primary={
                              t("common.spareparts.basket.delete") as string
                          }
                      />
                  </StyledListItemButton>
              )}
          </StyledList>
      </Popover>
  );
};
